import React from "react";
import { useState } from "react";
import TopScorers from "./TopScorers";
import TopAssists from "./TopAssists";
const FootballLeaguePlayerStats = ({
  topScorer,
  topAssists,
  dictionary,
  websiteBaseUrl,
  dataPath,
  dataClient,
}) => {
  const [activePlayerStats, setActivePlayerStats] = useState("scorers");
  const tabs = [
    {
      key: "scorers",
      label: "Top Scorers",
    },
    {
      key: "assists",
      label: "Top Assists",
    },
  ];
  return (
    <div className="player_stats">
      <nav className="inner_tab">
        <ul>
          {tabs.map(({ key, label }) => (
            <li
              key={key}
              className={`${activePlayerStats === key ? "active" : ""}`}
              onClick={() => setActivePlayerStats(key)}
              data-name={key}
            >
              <button>{label}</button>
            </li>
          ))}
        </ul>
      </nav>

      {activePlayerStats === "scorers" ? (
        <>
          <div className="leg_head">
            <h2>Scorers</h2>
          </div>
          <TopScorers
            data={topScorer}
            dictionary={dictionary}
            websiteBaseUrl={websiteBaseUrl}
            dataPath={dataPath}
            dataClient={dataClient}
          />
        </>
      ) : (
        <>
          <div className="leg_head">
            <h2>Assists</h2>
          </div>
          <TopAssists
            data={topAssists}
            dictionary={dictionary}
            websiteBaseUrl={websiteBaseUrl}
            dataPath={dataPath}
            dataClient={dataClient}
          />
        </>
      )}
    </div>
  );
};

export default FootballLeaguePlayerStats;
